module.exports = __webpack_public_path__ + "static/media/chevron-down-filter.080a72ef.svg";